import { INIT, SUCCESS, LOADING, ERROR } from "../../../utils/constants";
import {
  GET_AZURE_ACTIVE_ALERT,
  GET_AZURE_ACTIVE_ALERT_SUCCESS,
  GET_AZURE_ACTIVE_ALERT_ERROR,
} from "./constant";

const initialState = {
  phase: INIT,
  azureActiveAlertList: null,
  error: null,
};

/**
 * User Reducer
 * @param {Object} state
 * @param {Object} action
 */

export function AzureActiveAlertStore(state = initialState, action) {
  switch (action.type) {
    case GET_AZURE_ACTIVE_ALERT:
      return {
        ...state,
        phase: LOADING,
      };
    case GET_AZURE_ACTIVE_ALERT_SUCCESS:
      return {
        ...state,
        phase: SUCCESS,
        azureActiveAlertList: action.data,
        error: null,
      };
    case GET_AZURE_ACTIVE_ALERT_ERROR:
      return { ...state, phase: ERROR, error: action.error };

    default:
      return state;
  }
}
